/**
 * Created by lency on 9/22/2016.
 */
import angular from 'angular';
import licenseComponent from './license.component';

import licenseIconsModule from './license-icons/license-icons';

let licenseModule = angular.module('license', [
    licenseIconsModule
])

    .component('license', licenseComponent)
    .name;

export default licenseModule;



// WEBPACK FOOTER //
// ./src/app/common/license/license.js